(async () => {
    if (!customElements.get("manuals-slider")) {
        const { default: Swiper, Navigation, Pagination } = await import("./swiper.esm-357e3607.async.js");
        Swiper.use([Navigation, Pagination]);
        class ManualsSlider extends HTMLElement {
            constructor() {
                super();
                this.initialize()
            }
            initialize() {
                this.slideCollapsibles = this.querySelectorAll("[data-collapsible-group]");
                this.swiperElement = this.querySelector("[data-manuals-slider]");
                this.swiper = new Swiper(this.swiperElement, {
                    spaceBetween: 15,
                    slidesPerView: "auto",
                    threshold: 10,
                    direction: "horizontal",
                    navigation: {
                        nextEl: this.querySelector("[data-manuals-next]"),
                        prevEl: this.querySelector("[data-manuals-previous]")
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 30
                        },
                        1440: {
                            spaceBetween: 50
                        }
                    }
                })
            }
            collapseAll() {
                this.slideCollapsibles.forEach((slide => {
                    slide.classList.remove("collapsible-is-open")
                }))
            }
            focusSlide(index) {
                this.openCollapsible(index);
                this.swiper.slideTo(index, 200);
                this.scrollTo()
            }
            openCollapsible(index) {
                this.slideCollapsibles.forEach((slide => {
                    if (parseInt(slide.parentNode.getAttribute("data-slide")) === index) {
                        slide.classList.add("collapsible-is-open")
                    } else {
                        slide.classList.remove("collapsible-is-open")
                    }
                }))
            }
            scrollTo() {
                window.scrollTo({
                    top: this.offsetTop - 60,
                    behavior: "smooth"
                })
            }
        }
        customElements.define("manuals-slider", ManualsSlider)
    }
})();
//# sourceMappingURL=manuals-slider.js.map